// Library state — cursor-based pagination (matches Worker API)
import { createMapStore } from '@lib/state/store.js';

export const libraryStore = createMapStore({
  videos: [],
  filter: 'newest',
  isLoading: false,
  hasLoadedOnce: false,
  error: null,
  pagination: {
    cursor: null,   // ISO datetime cursor for next page
    hasMore: true,
  },
});
